<template>
  <div>
    <el-row style="height: 60px; vertical-align: center; ">
    <el-col :span="24" style="vertical-align: center">
      <el-button type="primary" size="small" @click="showImport=true" style="margin-right: 15px">导入订单</el-button>

      <el-button type="primary" size="small" @click="sendGoods">批量备注</el-button>

      <el-link href="./static/template/beizhu.xls"  type="primary" style="margin-left: 20px">批量备注模板</el-link>

      <span style="margin-left: 150px"></span><span style="font-size: 12px"> 旗帜：</span>
      <el-select v-model="sellerFlag" size="mini" style="width: 100px" placeholder="请选择">
        <el-option
          v-for="item in flagOpto"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-input :rows="2" type="textarea" v-model="sameMemoTxt" style="width: 200px"></el-input>

      <el-button type="primary" size="small" @click="updateSameMemo">备注相同内容</el-button>
      <span style="font-size: 12px"> 只需导入订单号</span>

      </el-col>
    </el-row>
    <el-row  style="height: 40px;margin-top: 20px; display: none">
      <el-col :span="24">
        <el-checkbox v-model="append" @change="checkVer">保留原备注，追加新备注</el-checkbox>
        <el-checkbox v-model="nickAsTid" @change="checkVer">以旺旺名备注订单</el-checkbox>
        <el-checkbox v-model="spanMemo">有多个相同订单号时，内容合并</el-checkbox>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border :data="memoData" style="font-size: 12px" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="200px"></el-table-column>
          <el-table-column  prop="flg" label="备注旗帜" width="100px"></el-table-column>
          <el-table-column  prop="memo" label="备注内容" ></el-table-column>
          <el-table-column  prop="status" label="状态" width="400px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="导入订单"
      :visible.sync="showImport"
      width="50%"
      center>
      <span style="margin-left:20px; margin-bottom: 30px">复制Excel表格里的订单，在这里粘贴（格式：订单号，备注旗帜，备注内容）</span>
      <el-input :rows="15" type="textarea" v-model="memoTxt"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="uploadData">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"
  import copy from "../api/copy"

  export default {
    name: "SellerMemo",
    data(){
      return{
        deny:0,
        version:'',
        append:false,
        nickAsTid:false,
        spanMemo:false,
        showImport:false,
        memoTxt:'',
        sameMemoTxt:'',
        memoData:[],
        sendValue:'offline',
        sendOpto:[{label:'自己联系',value:'offline'}],
        sellerFlag: 0,
        flagOpto:[{value:0,label:'0-灰色'},{value:1,label:'1-红色'},{value:2,label:'2-蓝色'},{value:3,label:'3-绿色'},{value:4,label:'4-黄色'}],


      }
    },
    methods:{
      indexMethod(index)
      {
        return index + 1;
      },
      checkVer:function(){
        if(this.version != "2"){
          this.append = true;
          this.nickAsTid = false;
          this.$message.error("该功能需要订购高级版才可使用！");
          return;
        }
      },
      getMemoData:function () {
        let param={
          nick:storage.get("nick"),
        }
        $api.post("/memo/get", param, response =>{
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.memoData = dataResult.data;
          }
          else{
            this.$message.error(dataResult);
            this.deny=1;
          }
        })
      },
      uploadData:function () {
        this.showImport = false;
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        let param={
          nick:storage.get("nick"),
          txt: this.memoTxt,
          nickAsTid: this.nickAsTid,
        }
        $api.post("/memo/import", param, response =>{
          console.log(response)
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.memoTxt = '';
            this.getMemoData();
            console.log("end.")
          }
          else{
            this.$message.error(dataResult.data.message);
          }
        })
      },
      sendGoods:function () {
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        let param={
          nick:storage.get("nick"),
          append: this.append,
          nickAsTid: this.nickAsTid,
          spanMemo: this.spanMemo
        }
        $api.post("/memo/update", param, response =>{
          console.log(response)
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){

            this.getMemoData();
            this.$message.success("批量备注完成。")
          }
          else{
            this.$message.error(dataResult.data.message);
          }
        })
      },
      updateSameMemo:function () {
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        let param={
          nick:storage.get("nick"),
          append: this.append,
          nickAsTid: this.nickAsTid,
          spanMemo: this.spanMemo,
          sellerFlag: this.sellerFlag,
          sellerMemo: this.sameMemoTxt,
        }
        $api.post("/memo/updateSameMemo", param, response =>{
          console.log(response)
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){

            this.getMemoData();
            this.$message.success("批量备注完成。")
          }
          else{
            this.$message.error(dataResult.data.message);
          }
        })
      },
      getVersion:function(){
        let param={
          nick:storage.get("nick")
        }
        $api.post("/getVersion", param,response=>{
          let dataResult = response.data;
          if(dataResult.state=="1" && dataResult.message == "ok"){
            this.version = dataResult.data;
          }else{
            console.log(dataResult.message);
          }
        })
      },
    },
    mounted(){
      this.getMemoData();

    }
  }
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/page/SellerMemo.vue